module.exports = __webpack_public_path__ + "static/media/mobile-2-2.ed96ec1a.gif";